function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { useTheme } from 'styled-components';
import { useSelector } from 'react-redux';
import { getProductTypeLabel, getPeriodsPerformance, getFundsCategoriesPath, getFundsCategoryPath } from '@finect/front-resources/Products';
import { Tiles } from '../../Tiles';
import { Section } from '../../Section';
import { PercentLabel } from '../../Products';
import { breakPointsSet3 } from '../../Carousel';
import { IconCard } from '../../Cards';
import { sectors } from './data';
export var FundSectorsCarousel = function FundSectorsCarousel(_ref) {
  var productType = _ref.productType;
  var theme = useTheme();
  var categories = useSelector(function (state) {
    return state.fund.categories;
  });
  var display = categories.filter(function (cat) {
    return cat.alias.includes('sector');
  }).map(function (cat) {
    var sector = sectors.find(function (sec) {
      return sec.link === cat.alias;
    });
    if (!sector) {
      return null;
    }
    return _objectSpread(_objectSpread({}, cat), sector);
  }).filter(function (item) {
    return Boolean(item);
  });
  var literal = getProductTypeLabel(productType, 'shortPlural', 'lowercase');
  var link = {
    text: 'Ver todas las categorías',
    href: getFundsCategoriesPath(theme, productType)
  };
  return React.createElement(Section, {
    title: "Categor\xEDas tem\xE1ticas de ".concat(literal),
    link: link,
    subtitle: "Rentabilidades medias de la categor\xEDa en Euros en los \xFAltimos 12 meses",
    bottomMargin: true,
    noMargins: true
  }, display.length === 0 ? React.createElement("div", {
    style: {
      minHeight: '180px'
    }
  }) : React.createElement(Tiles, {
    breakpoints: breakPointsSet3
  }, display.map(function (sector, index) {
    var performance = getPeriodsPerformance(sector.stats.performance, 'M12', 'accumulated');
    return React.createElement(IconCard, {
      key: index,
      icon: sector.backgroundImage,
      backgroundColor: "rgba(0, 0, 0, 0.1)",
      color: "#fff",
      backgroundImage: sector.backgroundImage,
      link: getFundsCategoryPath(theme, productType, sector),
      title: sector.title,
      subtitle: React.createElement(PercentLabel, {
        value: performance ? performance.value : null
      })
    });
  })));
};